import { forwardRef } from 'react';
import { cn } from '@/utils/helpers';

/**
 * Reusable Textarea component
 */
const Textarea = forwardRef(({
  label,
  error,
  success,
  hint,
  className,
  containerClassName,
  rows = 4,
  ...props
}, ref) => {
  const hasError = Boolean(error);
  const hasSuccess = Boolean(success);

  const textareaStyles = cn(
    'w-full px-4 py-3 rounded-lg border bg-white text-gray-900 placeholder-gray-400',
    'transition-all duration-200 resize-none',
    'focus:outline-none focus:ring-2 focus:border-transparent',
    hasError && 'border-red-300 focus:ring-red-500',
    hasSuccess && 'border-green-300 focus:ring-green-500',
    !hasError && !hasSuccess && 'border-gray-200 focus:ring-primary-500',
    className
  );

  return (
    <div className={cn('space-y-1.5', containerClassName)}>
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      
      <textarea
        ref={ref}
        rows={rows}
        className={textareaStyles}
        {...props}
      />

      {(error || success || hint) && (
        <p className={cn(
          'text-sm',
          hasError && 'text-red-500',
          hasSuccess && 'text-green-500',
          !hasError && !hasSuccess && 'text-gray-500'
        )}>
          {error || success || hint}
        </p>
      )}
    </div>
  );
});

Textarea.displayName = 'Textarea';

export default Textarea;
